"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverclaimSearchStore = exports.defaultOverclaimPagination = exports.OverclaimSearchFilters = void 0;
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const searchAPI = __importStar(require("@App/api/routes/search"));
const overclaimAPI = __importStar(require("@App/api/routes/overclaim"));
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const form_field_types_1 = require("@App/enum/form-field-types");
const overclaimStatusFilterGroup = {
    name: 'Status of Overclaim',
    allowMultiple: true,
    filterFields: [
        {
            OVERCLAIM: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'OVERCLAIM',
                label: '',
                children: 'Overclaim',
            },
        },
        {
            DISPUTE: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'DISPUTE',
                label: '',
                children: 'Dispute',
            },
        },
        {
            RESOLVED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'RESOLVED',
                label: '',
                children: 'Resolved',
            },
        },
        {
            MERGED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'MERGED',
                label: '',
                children: 'Merged',
            },
        },
        {
            CANCELED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'CANCELED',
                label: '',
                children: 'Canceled',
            },
        },
    ],
};
const overclaimSortByFilterGroup = {
    name: 'Sort By',
    allowMultiple: false,
    filterFields: [
        {
            SORT_BY: {
                type: form_field_types_1.FormFieldTypes.RADIO,
                name: 'SORT',
                options: [
                    { name: 'DATE', label: 'Most Recent Overclaim', default: true },
                    { name: 'ACTION_TIME', label: 'Remaining Action Time' },
                ],
                optional: false,
                label: '',
            },
        },
    ],
};
const overclaimDocumentStatusFilterGroup = {
    name: 'Document Status',
    allowMultiple: true,
    filterFields: [
        {
            DOCUMENT_NEEDED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'DOCUMENT_NEEDED',
                label: '',
                children: 'Document Needed',
            },
        },
        {
            DOCUMENT_PENDING: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'DOCUMENT_PENDING',
                label: '',
                children: 'Document Pending Review',
            },
        },
        {
            DOCUMENT_ACCEPTED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'DOCUMENT_ACCEPTED',
                label: '',
                children: 'Document Accepted',
            },
        },
    ],
};
const overclaimAmendmentStatusFilterGroup = {
    name: 'Amendment Status',
    allowMultiple: true,
    filterFields: [
        {
            AMENDMENT_NEEDED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'AMENDMENT_NEEDED',
                label: '',
                children: 'Document Needed',
            },
        },
        {
            AMENDMENT_PENDING: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'AMENDMENT_PENDING',
                label: '',
                children: 'Document Pending Review',
            },
        },
        {
            AMENDMENT_ACCEPTED: {
                type: form_field_types_1.FormFieldTypes.CHECKBOX,
                checked: false,
                name: 'AMENDMENT_ACCEPTED',
                label: '',
                children: 'Document Accepted',
            },
        },
    ],
};
exports.OverclaimSearchFilters = [
    overclaimStatusFilterGroup,
    overclaimSortByFilterGroup,
    overclaimDocumentStatusFilterGroup,
    overclaimAmendmentStatusFilterGroup,
];
exports.defaultOverclaimPagination = {
    page: 1,
    limit: 10,
};
const defaultOverclaimSelectionCriteria = [
    {
        id: get_search_query_1.SEARCH_OVERCLAIM_WORK_OPTIONS[0].id,
        selectedOption: get_search_query_1.SEARCH_OVERCLAIM_WORK_OPTIONS[0],
        searchTerm: '',
        isFixed: true,
    },
];
class OverclaimSearchStore {
    createOverclaimCriteriaStore() {
        const maxCriteria = 3;
        return new search_criteria_store_1.default(defaultOverclaimSelectionCriteria, get_search_query_1.SEARCH_OVERCLAIM_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.none, maxCriteria, ['MLC_OVERCLAIM', 'MLC_DISPUTE']);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolderPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.defaultOverclaimPagination
        });
        Object.defineProperty(this, "_overclaimSelectionQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { overclaimSearchFilter: ['DATE'] }
        });
        Object.defineProperty(this, "_overclaimStatusCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchForWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callBackPagination) => __awaiter(this, void 0, void 0, function* () {
                if (callBackPagination) {
                    this._pagination = callBackPagination;
                }
                yield this.getWorksRightsHolder(this.rootStore.rightsholderStore.currentRightsholderId, this._pagination, Object.assign(Object.assign(Object.assign({}, this._overclaimSelectionQuery), this._currentSearchFilters), { overclaim: true }));
                const page = this._pagination.page ? this._pagination.page : 1;
                this.setCurrentPaginationPage(page);
            })
        });
        Object.defineProperty(this, "setupOverclaimStatusCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (rightsholderId) => __awaiter(this, void 0, void 0, function* () {
                const searchResponse = yield overclaimAPI.getOverclaimStatusCounts(rightsholderId);
                this._overclaimStatusCounts = searchResponse.data;
            })
        });
        Object.defineProperty(this, "changeSearchResultsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newLimit) => {
                const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(this._pagination, this._worksRightsHolder ? this._worksRightsHolder.count : 1, newLimit);
                this.setCurrentPaginationLimit(newLimit);
                this.setCurrentPaginationPage(newPage);
                const pagination = {
                    page: newPage,
                    limit: newLimit,
                };
                return this.searchForWorks(pagination);
            }
        });
        (0, mobx_1.makeObservable)(this, {
            _worksRightsHolder: mobx_1.observable,
            _worksRightsHolderPaginationInfo: mobx_1.observable,
            _pagination: mobx_1.observable,
            _currentSearchFilters: mobx_1.observable,
            isDefaultPagination: mobx_1.computed,
            destroyOverclaimCriteria: mobx_1.action,
            _overclaimStatusCounts: mobx_1.observable,
        });
        this.rootStore = rootStore;
    }
    get pagination() {
        return this._pagination;
    }
    get limit() {
        var _a;
        return (_a = this._pagination.limit) !== null && _a !== void 0 ? _a : 10;
    }
    get isDefaultPagination() {
        return (0, lodash_1.isEqual)(this._pagination, exports.defaultOverclaimPagination);
    }
    get worksRightsHolder() {
        return this._worksRightsHolder;
    }
    get worksRightsHolderPaginationInfo() {
        return this._worksRightsHolderPaginationInfo;
    }
    get overclaimStatusCounts() {
        return this._overclaimStatusCounts;
    }
    get overclaimSearchQuery() {
        return this._overclaimSelectionQuery;
    }
    setCurrentSearchFilters(filters) {
        this._currentSearchFilters = filters;
    }
    setCurrentPaginationLimit(limit) {
        this._pagination.limit = limit;
    }
    setCurrentPaginationPage(page) {
        this._pagination.page = page;
    }
    setOverclaimSelectionSearchQuery(overclaimSelectionQuery, filter) {
        this._overclaimSelectionQuery = overclaimSelectionQuery;
    }
    getWorksRightsHolder(rightsHolderId, pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                // get info with search
                const searchResponse = yield searchAPI.searchOverclaimsRH(rightsHolderId, pagination, search !== null && search !== void 0 ? search : {});
                const worksRightsHolder = (_a = searchResponse.data.results) === null || _a === void 0 ? void 0 : _a.map((item) => (Object.assign({}, item.entity)));
                const response = {
                    count: searchResponse.data.count,
                    works: worksRightsHolder,
                    error: searchResponse.data.error,
                };
                (0, mobx_1.runInAction)(() => {
                    this._worksRightsHolder = response;
                    if (pagination.limit && pagination.page && response) {
                        const data = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page);
                        if (!data) {
                            return;
                        }
                        this._worksRightsHolderPaginationInfo = data;
                    }
                });
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    destroyOverclaimCriteria() {
        this._pagination = exports.defaultOverclaimPagination;
        this._overclaimSelectionQuery = {};
        this._worksRightsHolder = undefined;
        this._worksRightsHolderPaginationInfo = undefined;
        this._overclaimStatusCounts = undefined;
        this._currentSearchFilters = { overclaimSearchFilter: [] };
    }
}
exports.OverclaimSearchStore = OverclaimSearchStore;
